export enum ProductTypes
{
    DOCS = 0,
    WHATSAPP = 1,
    SMS = 3
}